import React from 'react';

import { OsmMap } from './osm_map';

export class GmapsMap extends OsmMap {
  constructor(props) {
    super(props);
  }

  setCenterAndZoom() {
    this.map.setOptions({...this.props.centerAndZoom});
  }

  fitBounds() {
    let bounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(this.props.bounds[0]),
      new google.maps.LatLng(this.props.bounds[1])
    )
    this.map.fitBounds(bounds);
  }

  getCenter() {
    return this.map.getCenter() && this.map.getCenter().toJSON();
  }

  getBounds() {
    let bounds = this.map.getBounds();
    return [bounds.getSouthWest().toJSON(), bounds.getNorthEast().toJSON()]
  }

  addListeners() {
    let events = [
      ['tilesloaded', 'handleMapLoad'],
      ['center_changed', 'handleMapMove'],
      ['zoom_changed', 'handleMapZoom']
    ];
    events.forEach(event => {
      const addListener = google.maps.event.addListener;
      const listener = addListener(this.map, event[0], this[event[1]]);
      this.listeners.push(listener);
    });
  }

  removeListeners() {
    if (window.google && this.listeners) {
      this.listeners.forEach((listener) => {
        google.maps.event.removeListener(listener);
      });
    }
  }

  getMaxBounds(corners) {
    const corner1 = new google.maps.LatLng(corners[0][0], corners[0][1]),
          corner2 = new google.maps.LatLng(corners[1][0], corners[1][1]);
    
    return new google.maps.LatLngBounds(corner1, corner2);
  }

  createMap() {
    const latLngBounds = this.getMaxBounds(this.props.maxBoundsCorners);
    this.map = new google.maps.Map(this.node, {
      ...this.props,
      center: this.props.centerAndZoom.center,
      zoom: this.props.centerAndZoom.zoom,
      streetViewControl: true,
      streetViewControlOptions: {
        position: google.maps.ControlPosition.TOP_RIGHT
      },
      fullscreenControl: false,
      restriction: {latLngBounds: latLngBounds}
    });
    this.map.streetView = new google.maps.StreetViewPanorama(this.node, {
      ...this.props,
      visible: false,
      enableCloseButton: true,
      addressControlOptions: {
        position: google.maps.ControlPosition.TOP_RIGHT
      },
      fullscreenControl: false
    });
  }
}
